import isPropValid from "@emotion/is-prop-valid";
import React from "react";
import { StyleSheetManager, WebTarget } from "styled-components";
import { Brand } from "types/common";
import GlobalTheme from "./components/GlobalTheme";
import { HeroBanner } from "./components/HeroBanner/HeroBanner";
import { InGridBanners } from "./components/InGridBanners/InGridBanners";
import { Modals } from "./components/Modals/Modals";
import { QuickFilterCarousel } from "./components/QuickFilterCarousel/QuickFilterCarousel";
import { GlobalConfigProvider } from "./context/GlobalConfig";
import { SlotConfigProvider } from "./context/SlotConfig";
import { TabConfigProvider } from "./context/TabContext";
import DevNav from "./views/DevNav";
import PLPGrid from "./views/PLPGrid";
import Tabs from "./views/Tabs";

export interface AppProps extends ClientState {
  brand: Brand;
}

const shouldForwardProp = (propName: string, target: WebTarget | undefined) => {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};

const App: React.FC<AppProps> = function App({ brand, path, preconnect, slots, tabs, defaultTab }: AppProps) {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      {preconnect.map((origin) => (
        <link key={origin} data-testid="content-preconnect-link" rel="preconnect" href={origin} />
      ))}
      <DevNav path={path} />
      <GlobalTheme brand={brand} />
      <GlobalConfigProvider value={{ brand }}>
        <SlotConfigProvider value={slots} initPath={path}>
          <HeroBanner />
          <QuickFilterCarousel />
          <InGridBanners />
          <Modals />
        </SlotConfigProvider>
        <TabConfigProvider value={{ tabs, defaultTab }} initPath={path}>
          <Tabs />
        </TabConfigProvider>
      </GlobalConfigProvider>
      <PLPGrid />
    </StyleSheetManager>
  );
};

export default App;
